import { render, staticRenderFns } from "./Ribbon.vue?vue&type=template&id=1e48e00a&scoped=true&"
import script from "./Ribbon.vue?vue&type=script&lang=js&"
export * from "./Ribbon.vue?vue&type=script&lang=js&"
import style0 from "./Ribbon.vue?vue&type=style&index=0&id=1e48e00a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../Valuation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e48e00a",
  null
  
)

export default component.exports